import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { getnoticUserList, delenoticUserList } from "@/api/dataAll/noticUser";
import addNotic from "./components/addNoticUser";
import { mapState } from "vuex";
export default {
  name: "noticUserList",
  components: {
    addNotic: addNotic
  },
  mixins: [tabulation],
  data: function data() {
    return {
      total: 0,
      pagrSize: 10,
      addWayConfig: false,
      showing: false,
      searchData: {
        page_size: 10,
        page: 1
      },
      searchpkgt: [],
      tableData: []
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick(e) {
      var _this = this;

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.reqLoading = true;
      this.searchData.page = e;
      getnoticUserList(this.searchData).then(function (res) {
        if (res.status == 200) {
          if (!res.data.data.length && _this.searchData.page > 1) {
            _this.searchClick(e - 1);
          } else {
            var list = ['game', 'platform', 'channel', 'pkg'];
            _this.tableData = res.data.data.length ? _this.$utils.dataConversion(res.data.data, list) : [];
            _this.total = res.data.total - 0 || 0;

            _this.$nextTick(function () {
              _this.getTableRight();
            });
          }
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    changeShow: function changeShow(val) {
      this.showing = val;
    },
    handleSource: function handleSource(row) {
      var _this2 = this;

      this.addWayConfig = true;
      this.$nextTick(function () {
        _this2.showing = true;

        _this2.$refs.addWayConfig.init(row);
      });
    },
    handleDelete: function handleDelete(row) {
      var _this3 = this;

      this.$confirm(this.$t('confirmDeleteData'), this.$t('tip'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                delenoticUserList({
                  special_product_id: row.product_id,
                  id: row.id
                }).then(function (res) {
                  if (res.status == 200) {
                    _this3.searchClick(_this3.searchData.page);

                    _this3.$message({
                      type: "success",
                      message: _this3.$t('deleteSuccessExclamation')
                    });
                  }
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      })));
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('idLabel'),
        prop: 'id'
      }, {
        label: this.$t('date'),
        prop: 'timestamp'
      }, {
        label: this.$t('game'),
        prop: 'game_reveal'
      }, {
        label: this.$t('platform'),
        prop: 'platform_reveal'
      }, {
        label: this.$t('channel'),
        prop: 'channel_reveal'
      }, {
        label: this.$t('pkg'),
        prop: 'pkg_reveal'
      }, {
        label: this.$t('emailList'),
        prop: 'email_list'
      }];
      var data = this.tableData;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};